"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _types = require("./types");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactMultiselectDropdownBootstrap = _interopRequireDefault(require("react-multiselect-dropdown-bootstrap"));

var SankeyEditionPropTypes = {
  data: _propTypes.default.shape(_types.SankeyDataPropTypes).isRequired,
  set_data: _propTypes.default.func.isRequired
};

var SankeyEdition = function SankeyEdition(_ref) {
  var data = _ref.data,
      set_data = _ref.set_data;
  var tags_catalog = data.tags_catalog;

  var handleSimpleDropdown = function handleSimpleDropdown(evt, tags_group) {
    var val = evt.target.value;
    Object.entries(tags_group.tags).forEach(function (tag) {
      return tag[1].selected = val === tag[1].name;
    });
    set_data((0, _objectSpread2.default)({}, data)); // Zoom sur les parties du SANKEY affichées à l'écran
    // A faire, et il y a sans doute mieux
    //console.log(d3.select('.g_nodes'))    
    // setTimeout(function () {
    //   const nodeWidth = (d3.select('.g_nodes').node() as any).getBoundingClientRect().width
    //   const svgWidth = (d3.select('svg').node() as any).getBoundingClientRect().width
    //   console.log(nodeWidth)
    //   console.log(svgWidth)
    //   console.log(svgWidth / nodeWidth)
    //   nodes
    //     .filter(function (d: any) { return d.visible })
    //     .forEach(function (d) {
    //       //console.log(d3.select('gg_' + d.idNode).node())
    //       d3.select('ggg_' + d.idNode)
    //         .attr('transform', 'translateX(150px)')
    //     })
    //   // d3.selectAll('.node')
    //   //   .filter(function (d: any) { return d.visible })
    //   //   //.attr('transform', 'translate('+svgWidth / nodeWidth+'%,0)')
    //   //   .each(function (d) {
    //   //     // console.log(this)
    //   //     //(d as any).x = (d as any).x * (svgWidth / nodeWidth.width) - nodeWidth.left
    //   //   })
    //   set_data({ ...data })
    // }, 2000)
  };

  var handleMultiDropdown = function handleMultiDropdown(selected, tags_group) {
    Object.entries(tags_group.tags).forEach(function (tag) {
      return tag[1].selected = selected.includes(tag[1].name);
    });
    set_data((0, _objectSpread2.default)({}, data));
  };

  var addDropdown = function addDropdown() {
    var banner_grouptag = Object.entries(tags_catalog).filter(function (_ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          tags_group = _ref3[1];

      return tags_group.banner == 'one' || tags_group.banner == 'multi';
    });
    var simpleDrop = banner_grouptag.filter(function (_ref4) {
      var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
          tags_group = _ref5[1];

      return tags_group.banner == 'one';
    }).map(function (_ref6) {
      var _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
          tags_group = _ref7[1];

      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
        key: tags_group.group_name
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, tags_group.group_name), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
        style: {
          width: '100px'
        }
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
        key: tags_group.group_name,
        placeholder: "all",
        onChange: function onChange(evt) {
          handleSimpleDropdown(evt, tags_group);
        }
      }, Object.entries(tags_group.tags).map(function (_ref8) {
        var _ref9 = (0, _slicedToArray2.default)(_ref8, 2),
            tag_key = _ref9[0],
            tag = _ref9[1];

        return /*#__PURE__*/_react.default.createElement("option", {
          key: tag_key,
          value: tag_key
        }, tag.name);
      }))));
    });
    var multiDrop = banner_grouptag.filter(function (_ref10) {
      var _ref11 = (0, _slicedToArray2.default)(_ref10, 2),
          tags_group = _ref11[1];

      return tags_group.banner == 'multi';
    }).map(function (_ref12) {
      var _ref13 = (0, _slicedToArray2.default)(_ref12, 2),
          tags_group = _ref13[1];

      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
        key: tags_group.group_name
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, tags_group.group_name), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
        style: {
          width: '100px'
        }
      }, /*#__PURE__*/_react.default.createElement(_reactMultiselectDropdownBootstrap.default, {
        key: tags_group.group_name,
        selected: Object.entries(tags_group.tags).map(function (tag) {
          return tag[1].selected ? tag[1].name : null;
        }).filter(function (tag_name) {
          return tag_name !== null;
        }),
        name: tags_group.group_name,
        options: Object.entries(tags_group.tags).map(function (tag) {
          return tag[1].name;
        }),
        handleOnChange: function handleOnChange(selected) {
          handleMultiDropdown(selected, tags_group);
        }
      })));
    });
    return [simpleDrop, multiDrop]; // return tags_catalog.filter(d => { return d.banner == 'one' || d.banner == 'multi' })
    //   .map((t, i) => <Form.Select>{t.tags.map((n, y) => <option key={y} value={n}>{n}</option>)} </Form.Select>)
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "herowrap",
    style: {
      'backgroundColor': 'gainsboro',
      'marginLeft': '0'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    style: {
      'marginTop': '90px',
      'marginBottom': '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 4
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, {
    id: "dropdown_banner"
  }, addDropdown())))));
};

var _default = SankeyEdition;
exports.default = _default;